import React from 'react';
import logo from './logo.svg';
import './Header.css';
import { Grid } from '@mui/material';

function Header() {
  const messageTitle = 'How You Think of Your Best Friend';
  const messageAuthor = 'Anthony Pearson';

  return (
    <header className="App-header">
      <Grid container wrap="nowrap" alignItems="center">
        <Grid item className="App-logo-container">
          <img src={logo} className="App-logo" alt="logo" />
        </Grid>
        <Grid item className="Flex-center">
          <div className="App-title">
            <u>{messageTitle}</u> by {messageAuthor}
          </div>
        </Grid>
      </Grid>
    </header>
  );
}

export default Header;